module.exports = __webpack_public_path__ + "img/Vector-1.f38f0885.svg";